// extracted by mini-css-extract-plugin
export var edaBtn = "link-btn-module--eda-btn--mafjf";
export var icon = "link-btn-module--icon--5Kel7";